import React, { PureComponent } from 'react';
import { get, set } from 'lodash';
import moment from 'moment/moment';
import { Table, OverlayTrigger, Popover, Row } from 'react-bootstrap';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../shared/components/VerbButton';
import HiddenInput from '../../../../../shared/components/formComponents/inputs/HiddenInput';
import DisplayOnlyInput from '../../../../../shared/components/formComponents/inputs/DisplayOnlyInput';
import VerbSelect from '../../../../../shared/components/formComponents/inputs/VerbSelect';

export default class CollectionLicensesTable extends PureComponent {
    static propTypes = {
        getLicensedDate: PropTypes.func,
        getCollectionName: PropTypes.func,
        currentValues: PropTypes.object,
        fields: PropTypes.object,
        availableCollections: PropTypes.array,
        selectedCollectionId: PropTypes.string,
        selectedCollection: PropTypes.object,
        handleCollectionChange: PropTypes.func,
        handleAddCollectionLicense: PropTypes.func,
        handleRemoveCollectionLicense: PropTypes.func,
        trackLicensesByLicencedCollectionId: PropTypes.object.isRequired,
        trackLicensesByTrackId: PropTypes.object.isRequired
    };

    _makeCollectionLicenseRemovalPopover = (collectionId, index) => {
        const { trackLicensesByLicencedCollectionId, handleRemoveCollectionLicense, trackLicensesByTrackId, fields } =
            this.props;
        const associatedLearningAssetIdsToRemove = Object.keys(
            get(trackLicensesByLicencedCollectionId, collectionId, {})
        ).filter((assetId) => trackLicensesByLicencedCollectionId[collectionId][assetId].length === 1);

        const confirmButton = (
            <VerbButton
                buttonType={VERB_BUTTON_TYPE.PRIMARY_DEFAULT}
                buttonText={'OK'}
                fontAwesomeIcon={'fa-trash'}
                title={'Remove TrackLicense'}
                onClick={() => handleRemoveCollectionLicense(fields, index)}
            />
        );

        if (associatedLearningAssetIdsToRemove.length) {
            return (
                <Popover
                    id={'collection-license-removal-popover'}
                    className={'collection-license-removal-popover admin-popover'}
                >
                    <p className={'license-removal-message'}>
                        This action will also remove the following from Company Learning Asset licenses
                    </p>
                    <div className={'associated-learning-assets-container'}>
                        <Row>
                            {associatedLearningAssetIdsToRemove.map((assetId) => (
                                <Row key={assetId}>
                                    <p className={'asset-name'}>
                                        -{' '}
                                        {(trackLicensesByTrackId[assetId] &&
                                            trackLicensesByTrackId[assetId].trackName) ||
                                            ''}
                                    </p>
                                </Row>
                            ))}
                        </Row>
                    </div>
                    <div className={'removal-submission-buttons-container'}>{confirmButton}</div>
                </Popover>
            );
        }
        return (
            <Popover
                id={'collection-license-removal-popover'}
                className={'collection-license-removal-popover admin-popover'}
            >
                <p className={'license-removal-message no-side-effect'}>
                    Removing the collection license will block the company's users from accessing the collection.
                </p>
                <div className={'removal-submission-buttons-container'}>{confirmButton}</div>
            </Popover>
        );
    };

    _renderTable = (currentValues, fields) => {
        const { getLicensedDate, getCollectionName } = this.props;
        if (fields && fields.length > 0) {
            return (
                <Table striped={false} bordered={false} hover={true}>
                    <thead>
                        <tr>
                            <th className={'buttonCell'}>Actions</th>
                            <th hidden>CollectionId</th>
                            <th>Collection Name</th>
                            <th>Added On</th>
                        </tr>
                    </thead>
                    <tbody>
                        {fields.map((member, index) => {
                            const collectionId = get(currentValues, `${member}.collectionId`, '');
                            const collectionName = getCollectionName(collectionId);
                            if (collectionName !== '') {
                                set(currentValues, `${member}.collectionName`, collectionName);
                            }

                            const licensedDateTime = getLicensedDate(member);
                            const collectionLicenseRemovalPopover = this._makeCollectionLicenseRemovalPopover(
                                collectionId,
                                index
                            );

                            return (
                                <tr key={`${collectionId}-${index}`}>
                                    <td className={'buttonCell'}>
                                        <OverlayTrigger
                                            trigger={'click'}
                                            transition={false}
                                            placement={'bottom'}
                                            rootClose
                                            overlay={collectionLicenseRemovalPopover}
                                        >
                                            <VerbButton
                                                buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                                                fontAwesomeIcon={'fa-trash'}
                                            />
                                        </OverlayTrigger>
                                    </td>
                                    <td hidden>
                                        <Field name={`${member}.collectionId`} component={HiddenInput} />
                                    </td>
                                    <td>
                                        <Field name={`${member}.collectionName`} component={DisplayOnlyInput} />
                                    </td>
                                    <td>{licensedDateTime ? moment(licensedDateTime).format('MMM Do YYYY') : null}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            );
        }
        return null;
    };

    render() {
        const {
            selectedCollectionId,
            selectedCollection,
            fields,
            currentValues,
            availableCollections,
            handleCollectionChange,
            handleAddCollectionLicense
        } = this.props;
        return (
            <div>
                <div className={'row'}>
                    <div className={'col-8'}>
                        <VerbSelect
                            placeholder={'Select Collection'}
                            className={'reactSelect'}
                            value={selectedCollectionId}
                            labelKey={'name'}
                            valueKey={'_id'}
                            onChange={handleCollectionChange}
                            options={availableCollections}
                        />
                    </div>
                    <div className={'col-4'}>
                        <VerbButton
                            className={'full-width'}
                            fontAwesomeIcon={'fa-plus'}
                            disabled={!selectedCollectionId}
                            onClick={() =>
                                selectedCollectionId ? handleAddCollectionLicense(fields, selectedCollection) : null
                            }
                        >
                            Add Collection License
                        </VerbButton>
                    </div>
                </div>
                {this._renderTable(currentValues, fields)}
            </div>
        );
    }
}
